import { useState } from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FaWhatsapp, FaFacebookF, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
import Logo from "../assets/med-images/logo.svg";
import { FaArrowUpLong } from "react-icons/fa6";

const navigation = {
  "Get Help": [
    { name: "eShop", href: "#" },
    { name: "WeCare", href: "#" },
    { name: "Health Care Professional", href: "#" },
  ],

  Policies: [
    { name: "Terms of Sale", href: "#" },
    { name: "Privacy Statement", href: "#" },
    { name: "Terms of Use", href: "#" },
    { name: "Cookie Policy", href: "#" },
    { name: "Cookie preferences", href: "#" },
  ],
  "Social Media": [
    { name: "Instagram", href: "#", icon: FaInstagram },
    { name: "Facebook", href: "#", icon: FaFacebookF },
    { name: "YouTube", href: "#", icon: FaYoutube },
  ],
};

function Footer() {
  return (
    <footer className="max-w-[1270px] mx-auto relative">
      <div className="py-5 px-5 lg:px-10 md:px-10">
        <div className="flex lg:flex-row lg:items-center flex-col items-start justify-between py-7">
          <div>
            <Link to="/" className="">
              <img className="h-6 w-auto" src={Logo} alt="logo" />
            </Link>
          </div>
          <div className="my-5 lg:my-0 flex lg:flex-row lg:items-center flex-col items-start justify-between">
            {navigation["Get Help"].map((item, index) => (
              <p key={index} className="flex items-center">
                <a
                  href={item.href}
                  className="text-lg font-semibold text-[#1010eb] hover:opacity-110"
                >
                  {item.name}
                </a>
                {index < navigation["Get Help"].length - 1 && (
                  <span className="text-[#1010eb] mx-5">
                    <div className="h-3 w-[1px] bg-[#1010eb] hidden lg:block "></div>
                  </span>
                )}
              </p>
            ))}
          </div>
          <div className="flex items-center space-x-4">
            {navigation["Social Media"].map((item, index) => (
              <a
                key={index}
                href={item.href}
                className={`text-2xl ${
                  item.name === "Instagram"
                    ? "text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-500 to-red-500"
                    : ""
                }`}
                style={{
                  color:
                    item.name === "Facebook"
                      ? "#1877F2"
                      : item.name === "YouTube"
                      ? "#FF0000"
                      : "inherit",
                }}
                aria-label={item.name}
              >
                <item.icon />
              </a>
            ))}
          </div>
        </div>
        <div className="border-t border-gray-300">
          <p className="my-3 text-gray-500 text-base text-left lg:text-center">
            For 24/7 diabetes technical product support please contact 01923
            205167
          </p>
          <div className="my-4 mx-auto flex flex-wrap items-center justify-start lg:justify-center">
            {navigation["Policies"].map((item, index) => (
              <p key={index} className="flex items-center">
                <a
                  href={item.href}
                  className="text-center text-sm font-semibold text-gray-800 hover:opacity-110"
                >
                  {item.name}
                </a>
                {index < navigation["Policies"].length - 1 && (
                  <span className="text-gray-800 mx-3 lg:mx-5">
                    <div className="h-3 w-[1px] bg-black"></div>
                  </span>
                )}
              </p>
            ))}
          </div>
          <p className="my-3 text-gray-500 text-sm text-left lg:text-center">
            See the device manuals for detailed information regarding the
            instructions for use, indications, contraindications, warnings,
            precautions, and potential adverse events. For further information,
            contact your local Medtronic representative. © 2024 Medtronic. All
            rights reserved Medtronic. Medtronic logo and Further, Together are
            trademarks of Medtronic.
          </p>
          <p className="font-semibold my-3 text-gray-800 text-sm text-left lg:text-center">
            Building 9, Croxley Park, Watford, Hertfordshire, WD18 8WW.
          </p>
        </div>
      </div>

      
    </footer>
  );
}

export default Footer;
